import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPhoneCircleGhost1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M4.539 4.539C6.285 2.793 8.829 2 12 2c3.17 0 5.715.793 7.461 2.539S22 8.829 22 12c0 3.17-.793 5.715-2.539 7.461S15.171 22 12 22c-3.17 0-5.715-.793-7.461-2.539S2 15.171 2 12c0-3.17.793-5.715 2.539-7.461'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.793 3.793C5.713 1.873 8.513 1 12 1s6.287.873 8.207 2.793S23 8.513 23 12s-.872 6.287-2.793 8.207C18.287 22.127 15.487 23 12 23s-6.287-.872-8.207-2.793C1.873 18.287 1 15.487 1 12s.873-6.287 2.793-8.207m1.414 1.414C3.794 6.62 3 8.821 3 12s.794 5.38 2.207 6.793S8.821 21 12 21s5.38-.794 6.793-2.207S21 15.179 21 12s-.794-5.38-2.207-6.793S15.179 3 12 3s-5.38.794-6.793 2.207'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      d='M17 15.165c0 .18-.04.365-.125.545s-.195.35-.34.51c-.246.27-.517.465-.822.59q-.45.189-.976.19-.768.001-1.633-.365a8.8 8.8 0 0 1-1.722-.99 14.4 14.4 0 0 1-1.643-1.4 14 14 0 0 1-1.397-1.635 9 9 0 0 1-.981-1.705Q7 10.05 7 9.27c0-.34.06-.665.18-.965q.178-.459.576-.835c.32-.315.671-.47 1.042-.47.14 0 .28.03.405.09.13.06.246.15.336.28L10.7 9.005q.134.186.2.35a.8.8 0 0 1 .07.305q0 .181-.105.355a1.7 1.7 0 0 1-.28.355l-.381.395a.27.27 0 0 0-.08.2c0 .04.005.075.015.115.015.04.03.07.04.1q.135.249.466.64.336.391.726.79c.27.265.53.51.796.735.26.22.476.37.646.46q.037.016.09.04.059.021.125.02c.085 0 .15-.03.205-.085l.38-.375q.189-.189.361-.28a.67.67 0 0 1 .356-.105.8.8 0 0 1 .306.065q.164.067.35.195l1.658 1.175q.194.134.275.32c.05.125.08.25.08.39'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPhoneCircleGhost1)
export default ForwardRef
